/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ExportState {
    Idle = 0,
    Exporting = 1,
    Pausing = 2,
    Paused = 3,
    Resuming = 4,
    Canceling = 5,
    Canceled = 6,
    Finished = 7,
    Failed = 8,
    ExportPauseDuringActivity = 9,
}
